<template>
  <div class="container">
    <div class="ui grid stackable">
      <div class="twelve wide column">
        <h1>Header Navigation</h1>
      </div>

      <listing-buttons :name="btnName" :route="route"></listing-buttons>
    </div>

    <div class="ui divider"></div>

    <div id="HeaderTable">
      <filter-bar></filter-bar>
      <vuetable
        ref="vuetable"
        :data="filteredHeaderItems"
        :fields="headerFields"
        :per-page="20"
        :sort-order="sortOrder"
      >
        <template slot="actions" slot-scope="item">
          <div class="table-button-container">
            <button class="ui button primary" @click="goToDetail(item)">
              <i class="fa fa-edit"></i>
            </button>
            <button class="ui button" @click="deleteModal(item.rowData.id)">
              <i class="fa fa-remove"></i>
            </button>
          </div>
        </template>
      </vuetable>

      <!-- <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination> -->
    </div>

    <div class="ui divider"></div>

    <div class="ui grid stackable">
      <div class="twelve wide column">
        <h1>Footer Navigation</h1>
      </div>

      <listing-buttons :name="btnName" :route="route"></listing-buttons>
    </div>

    <div class="ui divider"></div>

    <div id="FooterTable">
      <filter-bar></filter-bar>
      <vuetable
        ref="footerTable"
        :data="filteredFooterItems"
        :fields="footerFields"
        :per-page="20"
        :sort-order="sortOrder"
      >
        <template slot="actions" slot-scope="item">
          <div class="table-button-container">
            <button class="ui button primary" @click="goToDetail(item)">
              <i class="fa fa-edit"></i>
            </button>
            <button class="ui button" @click="deleteModal(item.rowData.id)">
              <i class="fa fa-remove"></i>
            </button>
          </div>
        </template>
      </vuetable>

      <!-- <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination> -->
    </div>

    <semantic-modal medium flip vertical :active.sync="showModal">
      <i class="close icon"></i>
      <div class="header">
        Are you sure you want to delete this navigation item?
      </div>
      <div class="actions">
        <div class="ui black deny button" @click="showModal = false">Nope</div>
        <div
          class="ui positive right labeled icon button"
          @click="navigationDelete()"
        >
          Yes
          <i class="checkmark icon"></i>
        </div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";

import SemanticModal from "vue-ya-semantic-modal";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

export default {
  name: "Navigation",
  computed: {
    /**
     * Header items, filtered by the current search term if any.
     * The filter-bar component emits the search via the
     * 'filter-set' event; we handle it by storing the term
     * in `filterText` and recomputing here. Empty term =
     * show all.
     */
    filteredHeaderItems() {
      return this._filterItems(this.headerItems);
    },
    filteredFooterItems() {
      return this._filterItems(this.footerItems);
    },
  },
  components: {
    Vuetable,
    SemanticModal: SemanticModal()
  },
  data() {
    return {
      btnName: "Navigation",
      route: "Edit Navigation",
      search: [
        {
          text: "Link Name",
          value: "name"
        },
        {
          text: "URL",
          value: "url"
        },
        {
          text: "None",
          value: ""
        }
      ],
      headerFields: [
        {
          name: "name",
          title: "Link Name",
          sortField: "name"
        },
        {
          name: "url",
          title: "URL",
          sortField: "url"
        },
        {
          name: "sortOrder",
          title: "Sort Order",
          sortField: "sortOrder"
        },
        // Buttons Column
        "__slot:actions"
      ],
      footerFields: [
        {
          name: "name",
          title: "Link Name",
          sortField: "name"
        },
        {
          name: "url",
          title: "URL",
          sortField: "url"
        },
        {
          name: "sortOrder",
          title: "Sort Order",
          sortField: "sortOrder"
        },
        // Buttons Column
        "__slot:actions"
      ],
      sortOrder: [
        {
          field: "sortOrder",
          sortField: "sortOrder",
          direction: "asc"
        }
      ],
      showModal: false,
      // Client-side filter text fed by the filter-bar
      // component. Empty = no filter.
      filterText: "",
      headerItems: [],
      footerItems: [],
      item: "",
    };
  },
  mounted() {
    // Wire up the filter-bar events. These were already
    // here — kept untouched.
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", () => this.onFilterReset());

    // Actually fetch the navigation data. This was the
    // bug — the methods to load header/footer items
    // existed but were never called, so both tables
    // displayed "No Data Available."
    this.getHeaderNavigation();
    this.getFooterNavigation();
  },
  methods: {
    /**
     * Apply the current filterText against an items array,
     * then sort ascending by sortOrder so the rows appear
     * in the same order they'll render on the actual nav.
     * Used by the computed properties feeding both
     * vuetables.
     *
     * Sort is stable: rows with the same sortOrder fall back
     * to alphabetical name order so the display is
     * deterministic when sortOrder values collide (which
     * can happen — the field isn't enforced unique).
     */
    _filterItems(items) {
      const term = String(this.filterText || "").toLowerCase();
      const filtered = !term
        ? (items || []).slice()
        : (items || []).filter((row) => {
            const name = String(row.name || "").toLowerCase();
            const url = String(row.url || "").toLowerCase();
            return name.includes(term) || url.includes(term);
          });

      return filtered.sort((a, b) => {
        const aOrder = Number(a.sortOrder);
        const bOrder = Number(b.sortOrder);
        const aN = isNaN(aOrder) ? Number.MAX_SAFE_INTEGER : aOrder;
        const bN = isNaN(bOrder) ? Number.MAX_SAFE_INTEGER : bOrder;
        if (aN !== bN) return aN - bN;
        return String(a.name || "").localeCompare(String(b.name || ""));
      });
    },

    deleteModal(id) {
      this.showModal = !this.showModal;
      this.item = id;

      return id;
    },
    getHeaderNavigation() {
      apiService.getHeaderNavigation().then(response => {
        // Backend returns a paginated wrapper:
        //   { data: [...], total, per_page, current_page, ... }
        // Accept both shapes (raw array or wrapped) so the
        // table works regardless of what the endpoint
        // returns. Defensive — if the API ever changes back
        // to a flat array, the fallback chain still picks
        // up the data.
        if (Array.isArray(response)) {
          this.headerItems = response;
        } else if (response && Array.isArray(response.data)) {
          this.headerItems = response.data;
        } else {
          this.headerItems = [];
        }
      });
    },
    getFooterNavigation() {
      apiService.getFooterNavigation().then(response => {
        if (Array.isArray(response)) {
          this.footerItems = response;
        } else if (response && Array.isArray(response.data)) {
          this.footerItems = response.data;
        } else {
          this.footerItems = [];
        }
      });
    },
    goToDetail(item) {
      this.$router.push({
        name: "Edit Navigation",
        params: {
          id: item.rowData.id
        }
      });
    },
    navigationDelete() {
      var item = this.item;

      apiService
        .deleteNavigation({ id: item })
        .then(request => {
          this.navigationSuccessful(request);
          this.showModal = !this.showModal;
          // Refresh the lists in place rather than
          // reloading the whole page — avoids the white
          // flash and keeps the user's scroll position.
          // The previous location.reload() was a hammer
          // that worked but felt heavy.
          this.getHeaderNavigation();
          this.getFooterNavigation();
        })
        .catch(err => this.navigationFailed(err));
    },
    navigationSuccessful(request) {
        (this.name = request.name),
        (this.url = request.url),
        (this.sortOrder = request.sortOrder);
    },
    navigationFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true
      });
    },
    /**
     * Filter-bar 'filter-set' handler — store the term so
     * the computed properties re-filter, then nudge
     * vuetable to re-render the visible rows. With
     * client-side data we don't need to refresh from the
     * server.
     */
    onFilterSet(filterText) {
      this.filterText = filterText || "";
    },
    onFilterReset() {
      this.filterText = "";
    }
  }
};
</script>

<style module></style>